import React from "react";
import "./TutorList.css";

const TutorList = ({ tutors, onEdit, onDelete }) => {
  if (tutors.length === 0) {
    return (
      <div className="tutor-list-no-tutors">
        <p>No tutors created yet. Click "Create New Tutor" to get started.</p>
      </div>
    );
  }

  const formatDate = (timestamp) => {
    if (!timestamp) return "N/A";
    if (timestamp._seconds) {
      return new Date(timestamp._seconds * 1000).toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    }
    return new Date(timestamp).toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className="tutor-list-container">
      <table className="table">
        <thead>
          <tr>
            <th>Tutor Name</th>
            <th>Description</th>
            <th>Model</th>
            <th>Status</th>
            <th>Created By</th>
            <th>Last Updated</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {tutors.map((tutor) => (
            <tr key={tutor.id}>
              <td>{tutor.name}</td>
              <td className="tutor-list-description">{tutor.description}</td>
              <td>{tutor.model}</td>
              <td>
                <span
                  className={`tutor-list-status-indicator ${
                    tutor.isActive !== false
                      ? "tutor-list-status-active"
                      : "tutor-list-status-inactive"
                  }`}
                >
                  {tutor.isActive !== false ? "Active" : "Inactive"}
                </span>
              </td>
              <td>{tutor.createdBy}</td>
              <td>{formatDate(tutor.updatedAt)}</td>
              <td className="tutor-list-actions">
                <button
                  className="tutor-list-edit-button"
                  onClick={() => onEdit(tutor)}
                  aria-label={`Edit ${tutor.name}`}
                >
                  Edit
                </button>
                <button
                  className="tutor-list-delete-button"
                  onClick={() => onDelete(tutor.id)}
                  aria-label={`Delete ${tutor.name}`}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TutorList;
